import { defineComponent as r, createBlock as i, openBlock as a, mergeProps as s, unref as f, withCtx as c, renderSlot as m } from "vue";
import p from "../Button.vue2.js";
import { useOUIAProps as l } from "../../helpers/ouia.js";
const A = /* @__PURE__ */ r({
  name: "PfAlertActionLink",
  __name: "AlertActionLink",
  setup(o) {
    const e = o, t = l({ id: e.ouiaId, safe: e.ouiaSafe });
    return (n, u) => (a(), i(p, s(f(t), {
      variant: "link",
      inline: ""
    }), {
      default: c(() => [
        m(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  A as default
};
